import Swal from "sweetalert2";
import { getCookie, csrf_headers } from "@/router";

function build_request_headers(token, include_content_type = false) {
  const headers = Object.assign(
    { Authorization: `Token ${token}` },
    csrf_headers(getCookie("csrftoken")),
  );

  if (include_content_type) {
    headers["Content-Type"] = "application/json";
  }

  return headers;
}

export const product_promo_api_helper_methods = {
  create_product_sales() {
    if (!this.validate_sale_form()) return;

    this.isLoading = true;
    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/create_sale/`,
      xhrFields: { withCredentials: true },
      data: JSON.stringify(this.build_sale_payload()),
      processData: true,
      contentType: "application/json",
      headers: build_request_headers(this.get_token()),
      success: (response) => {
        if (response.status === "success") {
          const sale_payload = this.build_sale_payload();
          Swal.fire({
            icon: "success",
            title: "Sale Created",
            text: response.message || "Sale was created successfully.",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            $("#product_sale_modal").modal("hide");
            this.$emit("sale-submitted", Object.assign({}, sale_payload, {
              sale: response.data,
            }));
            this.reset_form();
          });
        }
      },
      error: (response) => {
        this.show_error(response.message, "An error occurred while creating the sale, please try again.");
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  },
  get_catalogue_promo_codes() {
    const base_profile_id = this.get_selected_base_profile_id();
    if (!base_profile_id) return;

    this.is_loading = true;
    $.ajax({
      type: "GET",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/catalogue_promo_codes/`,
      data: {
        base_profile_id,
      },
      headers: {
        Authorization: `Token ${this.get_token()}`,
      },
      success: (response) => {
        if (response.status === "success") {
          this.catalogue_promo_codes = response.data || [];
        }
      },
      error: (response) => {
        this.show_error(response, "An error occurred while loading catalogue promo codes.");
      },
      complete: () => {
        this.is_loading = false;
      },
    });
  },
  show_error(response, fallback) {
    const response_data = response?.responseJSON || {};
    Swal.fire({
      icon: "error",
      title: "Error",
      text: response_data.message || fallback,
      showConfirmButton: false,
      timer: 3000,
    });
  },
};
